module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#bundle",
      toString: function () {
        return this.url;
      }
    }